import { Module } from '@nestjs/common';
import { SizesController } from './sizes.controller';
import { SizesService } from './sizes.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { TypeOrmModule } from '@nestjs/typeorm';
import { SizesAdapter} from './dto/sizes-adapter';
import { Sizes } from './sizes-entity';
import { LogsService } from '@gtpl/shared-services/user-logs';


@Module({
  imports: [
    TypeOrmModule.forFeature([Sizes]),
  ],
  controllers: [SizesController],
  providers: [SizesService,SizesAdapter,ApplicationExceptionHandler,LogsService],
  exports: [SizesService]
})
export class SizesModule {}
